import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import { useAuth } from "@/lib/auth";
import { toast, Toaster } from "sonner";

export default function Signin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <SiteLayout>
      <Toaster richColors position="top-center" />
      <section className="section-py container-x max-w-md">
        <h1 className="text-4xl font-extrabold tracking-tight">Welcome back.</h1>
        <p className="mt-2 text-muted-foreground">Sign in to see your submissions and payouts.</p>
        <form onSubmit={submit} className="mt-8 card-soft space-y-4" data-testid="signin-form">
          <div>
            <label className="text-xs font-bold uppercase text-muted-foreground">Email</label>
            <input data-testid="signin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full rounded-2xl border border-border bg-white px-4 py-3" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase text-muted-foreground">Password</label>
            <input data-testid="signin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full rounded-2xl border border-border bg-white px-4 py-3" />
          </div>
          <button data-testid="signin-submit" disabled={loading} className="btn-pill w-full">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          New here? <Link to="/signup" className="text-primary font-bold underline">Create an account</Link>
        </p>
      </section>
    </SiteLayout>
  );
}
